// Each private download must reach Storage for a fresh permission check.
// Request cache options alone did not bypass an already cached SDK URL in live QA.
export function createPrivateStorageFetch(projectUrl, fetchImpl = (...args) => fetch(...args), nonce = () => crypto.randomUUID()) {
 const origin = new URL(projectUrl).origin;
 return (input, init) => {
  const isRequest = typeof Request !== 'undefined' && input instanceof Request;
  const url = new URL(isRequest ? input.url : input);
  const method = (init?.method || (isRequest ? input.method : 'GET')).toUpperCase();
  if (method !== 'GET' || url.origin !== origin || !/^\/storage\/v1\/object\/(?:authenticated\/)?(?:resumes|forum-attachments)\//.test(url.pathname)) return fetchImpl(input, init);
  url.searchParams.set('cacheNonce', nonce());
  const options = { ...init, cache: 'no-store' };
  return fetchImpl(isRequest ? new Request(url, input) : url.href, options);
 };
}
